








































































































































































































































































































































import { Component, Vue, Ref, Watch } from "vue-property-decorator";
import {
  ProjectDetails,
  ContactPersonInfo,
  ProjectOperationSource,
} from "@/data/models/ProjectDetails";
import {
  getClientPanelDisplayNameFromAssignment,
  isDateIncludedInOtherAssignment,
} from "@/data/models/ClientPanelAssignment";
import { DeviceProjectAssignment } from "@/data/models/DeviceProjectAssignment";
import BaseDialogComponent from "@/components/common/BaseDialog.vue";

import DatePickerCompoment from "@/components/common/DatePicker.vue";
import { calculateAssignedDeviceName, generateRandomUuid } from "@/utils/Utils";
import {
  MeterReadingInfo,
} from "@/data/repository/PanelRepository";

import clone from "clone";

import { formatFloat, parseLocalizedFloat } from "@/utils/LocalisationHelper";
import {
  formatDateShort,
  toDatePickerFormat,
} from "@/utils/DateFormatter";
import {
  toStartOfDay,
  toEndOfDay,
  areDatesOnSameDay,
  areOnSameDay,
} from "@/utils/DateHelper";
import { firestore } from "firebase/app";

import ConfirmationDialogComponent from "@/components/common/ConfirmationDialog.vue";
import {
  getIresDeviceCategoryFromSerialNumber,
  IresDeviceCategory,
} from "@/data/models/IresDevice";

import { getActiveUser } from "@/data/repository/UserRepository";
import { canBeUsedAsElectricityMeterForOtherDevices, selectedPowerConsumptionMode } from "@/data/models/DeviceTemplate";
import { defineCategoriesAndTemplatesClientAccess } from "@/permissions/ClientPermissions";
import { DeviceCategoriesAndTemplatesModule } from "@/store/modules/DeviceCategoriesAndTemplatesModule";
import {
  getGenericDeviceDetails,
  getTemplateById,
} from "@/data/repository/GenericDeviceRepository";
import { DeviceOverview } from "@/data/models/DeviceOverview";
import { 
  ExternalElectricityMeterType,
  extractPowerConsumptionInput,
  GenericDeviceProjectAssignment, 
  ProjectPhase 
} from "@/data/models/GenericDeviceAssignment";
import { 
  deleteGenericDeviceAssignments,
  getAllGenericDeviceAssignmentsStartedOrEndedAfter,
  getGenericDeviceAssignmentsOfProject,
  saveGenericDeviceAssignment,
} from "@/data/repository/GenericDeviceAssignmentRepository";
import { GenericDevice } from "@/data/models/GenericDevice";
import { parsePowerConsumption } from "@/data/models/BaseDeviceInfo";
import {
  DEVICE_POWER_INPUT_ATTRIBUTE_TYPES,
  DeviceAssignmentPowerInput,
  DeviceAttributeType,
  DevicePowerConsumptionInput,
  DevicePowerUsageType,
  getDeviceAttributeTypeFromDeviceTemplate,
} from "@/data/models/DeviceAttribute";
import { getClientPanelAssignmentsOfProject, getNextAssignmentStartedAfter } from "@/data/repository/ClientPanelAssignmentRepository";
import { AllDevicesSettingsModule } from "@/store/modules/AllDevicesSettingsModule";
import {
  COLOR_BASE_DIALOG_BACKGROUND,
  COLOR_BASE_DIALOG_BACKGROUND_DARK,
  COLOR_BLACK_TEXT,
  COLOR_BLACK_TEXT_DARK,
  COLOR_ERROR_TEXT,
  COLOR_ERROR_TEXT_DARK,
  COLOR_READ_ONLY_TEXT,
  COLOR_READ_ONLY_TEXT_DARK,
  COLOR_WHITE_BACKGROUND,
  COLOR_WHITE_BACKGROUND_DARK,
} from "@/utils/colors";
import { themed } from "@/utils/Theme";
import { computeMinDateForGenericAssignment } from "@/utils/GenericDeviceAssignmentUtils";
import {
  hasActiveDependentAssignments as _hasActiveDependents,
  getLatestDependentAssignmentEndDate as _getLatestDependentEnd,
  computeCountingDeviceCoverage,
  isCountingCandidateDisabledByMinDate,
  shouldSkipMeterReadingEnforcement as _shouldSkipEnforcement,
} from "@/utils/CountingDeviceValidation";

enum AssignmentValidationResult {
  NotValidated,
  SaveData,
  SaveEnabled,
  SaveDisabled,
}

interface CountingAssignmentCandidate {
  id: string;
  assignmentStartDate: firestore.Timestamp;
  assignmentEndDate: firestore.Timestamp | null;
  /** For open assignments: the last valid day derived from the next assignment of the same device. */
  effectiveMaxEndDate: firestore.Timestamp | null;
  deviceName: string;
  deviceId: string;
  type: ExternalElectricityMeterType;
}

interface DynamicAssignmentField {
  type: DeviceAttributeType;
  label: string;
  inputType: "text" | "number";
}

@Component({
  components: {
    "confirmation-dialog": ConfirmationDialogComponent,
    "date-picker": DatePickerCompoment,
    "base-dialog": BaseDialogComponent,
  },
})
export default class AssignGenericDeviceToProjectComponent extends Vue {
  @Ref("baseDialog")
  baseDialogComponent!: BaseDialogComponent;

  @Ref("confirmationDialog")
  confirmationDialog!: ConfirmationDialogComponent;

  @Ref("endDatePicker")
  endDatePicker!: DatePickerCompoment;

  @Ref("startDatePicker")
  startDatePicker!: DatePickerCompoment;

  resolve?: (value: boolean) => void = undefined;
  reject?: (reason: string) => void = undefined;

  startedForAssignmentCreation = true;
  startedForAssignmentCorrection = true;

  genericDeviceOverviewToAssign!: DeviceOverview;
  targetProject!: ProjectDetails;
  contactPerson!: ContactPersonInfo;
  assignment!: GenericDeviceProjectAssignment;
  existingAssignments: GenericDeviceProjectAssignment[] = [];

  didLoadDeviceInfo = false;
  minDate: firestore.Timestamp | null = null;

  startDate = firestore.Timestamp.fromDate(new Date());
  endDate: firestore.Timestamp | null = null;

  maxEndDate = firestore.Timestamp.fromDate(new Date());

  didValidateStartDate = false;
  didValidateEndDate = false;

  assignmentValidationResult = AssignmentValidationResult.NotValidated;

  showContent = false;

  wasActiveAssignment = false;
  
  proposedMeterReadingStart: MeterReadingInfo = this.createEmptyMeterReadingInput();
  proposedMeterReadingEnd: MeterReadingInfo = this.createEmptyMeterReadingInput();
  meterReadingStart: MeterReadingInfo = this.createEmptyMeterReadingInput();
  meterReadingEnd: MeterReadingInfo = this.createEmptyMeterReadingInput();

  lastMeterReadingEndTargetDate: firestore.Timestamp | null = null;
  lastMeterReadingStartTargetDate: firestore.Timestamp | null = null;

  electricityMeterNumber: string | null = null;

  meterReadingEndInput = "";
  meterReadingStartInput = "";
  meterReadingEndError: string[] = [];
  assignmentOperatingHoursInput = "";
  assignmentOperatingHoursError: string[] = [];

  powerConsumption = 0;

  showProgressBar = false;

  deviceDetails: null | GenericDevice = null;
  currentTemplate: ReturnType<typeof getTemplateById> | null = null;

  inventoryNumber = "";

  countedViaExternalDevice = false;
  showCountingDeviceDialog = false;
  selectedCountingAssignmentId: string | null = null;
  countingAssignments: CountingAssignmentCandidate[] = [];
  countingDeviceErrorMessages: string[] = [];
  assignmentAttributeInputs: { [key: string]: string } = {};
  countedDeviceAssignments: GenericDeviceProjectAssignment[] = [];
  useForElectricityBilling = true;
  note: string | null = null;
  meterReadingStartHintValue: number | null = null;

  errorSnackbar = false;
  errorSnackbarText = "";
  successSnackbar = false;
  successSnackbarText = "";

  get activeUser() {
    return getActiveUser();
  }

  get isAllowedToDefineOwnDeviceCategoriesAndTemplates() {
    return defineCategoriesAndTemplatesClientAccess();
  }

  get localDeviceSettingsJson() {
    return DeviceCategoriesAndTemplatesModule.localDeviceCategoriesAndTemplates;
  }

  get sharedDeviceSettingsJson() {
    return DeviceCategoriesAndTemplatesModule.sharedDeviceCategoriesAndTemplates;
  }

  get deviceSettingsJson() {
    return this.isAllowedToDefineOwnDeviceCategoriesAndTemplates
      ? this.localDeviceSettingsJson
      : this.sharedDeviceSettingsJson;
  }

  get saveDisabled() {
    // In create mode we validate again on save, so keep the action available.
    // This avoids stale pre-validation UI state blocking valid assignments.
    if (this.isCreateMode) {
      return false;
    }

    return ![
      AssignmentValidationResult.SaveEnabled,
      AssignmentValidationResult.SaveData,
    ].includes(this.assignmentValidationResult);
  }

  get isStrictCounterCheckingEnabled() {
    return (
      AllDevicesSettingsModule
        .allDevicesSettings
        .projectDevicesSettings
        ?.enforceMeterReading ?? false
    );
  }

  /**
   * Skips strict meter reading enforcement for dependent devices
   * (counted via external meter) or devices not used for electricity billing.
   */
  get shouldSkipMeterReadingEnforcement() {
    return _shouldSkipEnforcement(this.countedViaExternalDevice, this.useForElectricityBilling);
  }

  get isCreateMode() {
    return this.startedForAssignmentCreation;
  }

  get isCorrectionMode() {
    return !this.startedForAssignmentCreation && this.startedForAssignmentCorrection;
  }

  get isReleaseMode() {
    return !this.startedForAssignmentCreation && !this.startedForAssignmentCorrection;
  }

  get isEditMode() {
    return !this.startedForAssignmentCreation;
  }

  get showEndDate() {
    return this.isEditMode;
  }

  get startDateInputEnabled() {
    return true;
  }

  get showEndMeterReading() {
    return this.isEditMode && !!this.endDate;
  }

  get showMeterReadingInputsSection() {
    return (
      this.powerUsageType === DevicePowerUsageType.ELECTRICITY_METER ||
      this.powerUsageType === DevicePowerUsageType.ELECTRICITY_METER_FOR_OTHER_DEVICES ||
      this.powerUsageType === DevicePowerUsageType.OPERATING_HOURS
    );
  }

  get isOperatingHoursMode() {
    return (
      this.powerUsageType === DevicePowerUsageType.OPERATING_HOURS ||
      this.powerUsageType === DevicePowerUsageType.OPERATING_HOURS_FROM_ASSIGNMENT
    );
  }

  get meterReadingSuffix() {
    return this.isOperatingHoursMode ? "h" : "kWh";
  }

  get meterReadingStartLabel() {
    return this.$t("assignDevice.meterReadingStart").toString();
  }

  get showUseForElectricityBillingOption() {
    // Android shows this option for meter-based assignment dialogs in create/edit/release.
    // Hide when counted via an external device — billing depends on the counting device.
    return this.showMeterReadingInputsSection && !this.countedViaExternalDevice;
  }

  get showStandaloneUseForElectricityBillingOption() {
    return this.powerUsageType === DevicePowerUsageType.OPERATING_HOURS_FROM_ASSIGNMENT && !this.showAssignmentHoursSection && !this.countedViaExternalDevice;
  }

  get showExternalCountingSection() {
    if (!this.showExternalElectricityMeterInfo) {
      return false;
    }

    // Show the section if there are fitting counting devices available
    // or the assignment is already counted via an external device.
    return this.countedViaExternalDevice || this.selectableCountingAssignments.length > 0;
  }

  get showAssignmentHoursSection() {
    return this.powerUsageType === DevicePowerUsageType.OPERATING_HOURS_FROM_ASSIGNMENT && this.isEditMode;
  }

  get canEditExternalCounting() {
    return this.isCreateMode || this.isCorrectionMode || this.isReleaseMode;
  }

  get meterReadingStartInputEnabled() {
    return !this.isReleaseMode;
  }

  get meterReadingEndInputEnabled() {
    return this.isEditMode;
  }

  get dynamicAttributeInputsEnabled() {
    return !this.isReleaseMode;
  }

  get dynamicAssignmentFields(): DynamicAssignmentField[] {
    const templateAttributes = this.currentTemplate?.deviceAttributes ?? [];
    const projectAssignmentDependentTypes = new Set(
      (this.deviceSettingsJson?.deviceAttributes ?? [])
        .filter((attribute) => attribute.isProjectAssignmentDependent)
        .map((attribute) => attribute.deviceAttributeType)
        .filter((value): value is DeviceAttributeType => !!value)
    );

    const excluded = new Set<DeviceAttributeType>([
      DeviceAttributeType.METER_READING,
      DeviceAttributeType.ELECTRICITY_METER_FOR_OTHER_DEVICES,
      DeviceAttributeType.OPERATING_HOURS,
      DeviceAttributeType.OPERATING_HOURS_FROM_ASSIGNMENT,
    ]);

    return templateAttributes
      .map((attribute) => attribute.attributeType)
      .filter((attributeType) => projectAssignmentDependentTypes.has(attributeType))
      .filter((attributeType) => !excluded.has(attributeType))
      .map((attributeType) => ({
        type: attributeType,
        label: this.getDynamicAttributeLabel(attributeType),
        inputType: attributeType === DeviceAttributeType.OPERATING_HOURS ||
          attributeType === DeviceAttributeType.OPERATING_HOURS_FROM_ASSIGNMENT
          ? "number"
          : "text",
      }));
  }

  get isCountingDevice() {
    return this.assignment?.electricityMeterForOtherDevices === true;
  }

  get hasActiveDependentAssignments(): boolean {
    return _hasActiveDependents(this.isCountingDevice, this.countedDeviceAssignments);
  }

  get latestDependentAssignmentEndDate(): firestore.Timestamp | null {
    return _getLatestDependentEnd(this.isCountingDevice, this.countedDeviceAssignments);
  }

  @Watch("genericDeviceOverviewToAssign", { immediate: true })
  onDeviceOverviewChanged() {
    const templateId = this.genericDeviceOverviewToAssign?.templateId;
    this.currentTemplate = templateId
      ? getTemplateById(this.deviceSettingsJson, templateId)
      : null;
  }

  
  get powerUsageType() {
    if (!this.currentTemplate) {
      return null;
    }
    return getDeviceAttributeTypeFromDeviceTemplate(this.currentTemplate);
  }

  get powerConsumptionPerHour() {
    const devicePowerConsumptionPerHour = this.deviceDetails?.powerConsumptionPerHour;
    if (
      devicePowerConsumptionPerHour !== undefined &&
      devicePowerConsumptionPerHour !== null
    ) {
      return devicePowerConsumptionPerHour;
    }

    const templatePowerConsumptionPerHour = this.currentTemplate?.deviceAttributes.find(
      (attribute) => attribute.attributeType === DeviceAttributeType.POWER_CONSUMPTION_PER_HOUR
    )?.defaultValue;

    return templatePowerConsumptionPerHour
      ? parsePowerConsumption(templatePowerConsumptionPerHour)
      : null;
  }

  get showExternalElectricityMeterInfo() {
    if (this.powerConsumptionPerHour) {
      const hasValidPowerConsumption =
        this.powerConsumptionPerHour > 0 && this.powerConsumptionPerHour !== 0;

      switch (this.powerUsageType) {
        case DevicePowerUsageType.ELECTRICITY_METER_FOR_OTHER_DEVICES:
          return false;
        case DevicePowerUsageType.NONE:
          return hasValidPowerConsumption;
        default:
          return true;
      }
    }

    return (
      this.powerUsageType !== DevicePowerUsageType.ELECTRICITY_METER_FOR_OTHER_DEVICES &&
      this.powerUsageType !== DevicePowerUsageType.NONE
    );
  }

  get countingDeviceOptions() {
    return this.selectableCountingAssignments.map((assignment) => ({
      value: assignment.id,
      text: `${assignment.deviceName} (${this.formatAssignmentRange(assignment.assignmentStartDate, assignment.assignmentEndDate)})`,
      disabled: this.isCountingAssignmentDisabledByMinDate(assignment),
    }));
  }

  get selectableCountingAssignments() {
    if (!this.isCreateMode) {
      return this.countingAssignments;
    }

    // In create mode, open assignment can only reference an open counting assignment.
    return this.countingAssignments.filter(
      (assignment) => assignment.assignmentEndDate === null
    );
  }

  /**
   * Returns true if the counting assignment's effective window ends before
   * the earliest allowed start date of this generic device.
   */
  isCountingAssignmentDisabledByMinDate(assignment: CountingAssignmentCandidate): boolean {
    if (!this.isCreateMode) return false;
    return isCountingCandidateDisabledByMinDate(assignment.effectiveMaxEndDate, this.minDate);
  }

  get selectedCountingAssignment() {
    return this.selectedCountingAssignmentId
      ? this.selectableCountingAssignments.find(
          (assignment) => assignment.id === this.selectedCountingAssignmentId
        ) ?? null
      : null;
  }

  get countingCoverageForCurrentSelection() {
    const selectedAssignment = this.selectedCountingAssignment;

    if (selectedAssignment) {
      const coverage = computeCountingDeviceCoverage(selectedAssignment);
      return {
        assignmentStartDate: coverage.start,
        assignmentEndDate: coverage.end,
      };
    }

    const externalInfo = this.assignment.externalElectricityMeterInfo;
    const assignmentStartDate = this.assignment.assignmentStartDate;

    // Fallback: resolve the concrete referenced assignment by deviceId + coverage of assignment start date.
    // This handles stale assignmentIds and ensures we cap dates to the actual historical assignment window.
    if (externalInfo?.deviceId && assignmentStartDate) {
      const matchingAssignment = this.countingAssignments
        .filter((assignment) => assignment.deviceId === externalInfo.deviceId)
        .filter(
          (assignment) =>
            assignment.assignmentStartDate.toMillis() <= assignmentStartDate.toMillis() &&
            (!assignment.assignmentEndDate ||
              assignment.assignmentEndDate.toMillis() >= assignmentStartDate.toMillis())
        )
        .sort((left, right) => right.assignmentStartDate.toMillis() - left.assignmentStartDate.toMillis())[0];

      if (matchingAssignment) {
        const coverage = computeCountingDeviceCoverage(matchingAssignment);
        return {
          assignmentStartDate: coverage.start,
          assignmentEndDate: coverage.end,
        };
      }
    }

    if (externalInfo) {
      return {
        assignmentStartDate: externalInfo.assignmentStartDate,
        assignmentEndDate: externalInfo.assignmentEndDate,
      };
    }

    return null;
  }

  get componentColorStyles() {
    return {
      "--assign-device-base-dialog-bg": themed(COLOR_BASE_DIALOG_BACKGROUND, COLOR_BASE_DIALOG_BACKGROUND_DARK),
      "--assign-device-black-text": themed(COLOR_BLACK_TEXT, COLOR_BLACK_TEXT_DARK),
      "--assign-device-error-text": themed(COLOR_ERROR_TEXT, COLOR_ERROR_TEXT_DARK),
      "--assign-device-readonly-text": themed(COLOR_READ_ONLY_TEXT, COLOR_READ_ONLY_TEXT_DARK),
      "--assign-device-white-bg": themed(COLOR_WHITE_BACKGROUND, COLOR_WHITE_BACKGROUND_DARK),
    };
  }

  get countingDeviceDialogHeaderFooterStyle() {
    return {
      background: themed(COLOR_BASE_DIALOG_BACKGROUND, COLOR_BASE_DIALOG_BACKGROUND_DARK),
    };
  }

  get countingDeviceErrorStyle() {
    return {
      color: themed(COLOR_ERROR_TEXT, COLOR_ERROR_TEXT_DARK),
    };
  }

  get selectedCountingDeviceName() {
    if (!this.selectedCountingAssignmentId) {
      return this.$t("common.select").toString();
    }

    return (
      this.countingAssignments.find(
        (assignment) => assignment.id === this.selectedCountingAssignmentId
      )?.deviceName ?? this.$t("common.select").toString()
    );
  }

  get allowedStartDates() {
    const dates = this.calculateStartDates(false);
    
    return (val: string) => dates.includes(val);
  }

  get allowedEndDates() {
    const dates = this.calculateStartDates(true);
    const minEndDateString = this.minEndDateString;
    
    return (val: string) => {
      if (minEndDateString && val < minEndDateString) {
        return false;
      }
      return dates.includes(val);
    };
  }

  /**
   * Local-time YYYY-MM-DD string of the earliest allowed end date for a
   * counting device (= latest dependent assignment end date), or null.
   */
  get minEndDateString(): string | null {
    const latestDependentEnd = this.latestDependentAssignmentEndDate;
    if (!latestDependentEnd) return null;
    return toDatePickerFormat(toStartOfDay(latestDependentEnd).toDate());
  }

  /**
   * Minimum allowed end date for the end date picker.
   * For counting devices, the end date must be >= the latest dependent
   * assignment end date so the counting device always covers all dependents.
   */
  get minEndDate(): firestore.Timestamp {
    const latestDependentEnd = this.latestDependentAssignmentEndDate;
    if (
      latestDependentEnd &&
      latestDependentEnd.toMillis() > this.startDate.toMillis()
    ) {
      return toStartOfDay(latestDependentEnd);
    }
    return this.startDate;
  }

  getDatePickerKey(timestamp: firestore.Timestamp) {
    const date = new Date(toStartOfDay(timestamp).toDate());
    date.setDate(date.getDate() + 1);
    return date.toISOString().split("T")[0];
  }

  isAllowedEndDate(timestamp: firestore.Timestamp) {
    return this.calculateStartDates(true).includes(this.getDatePickerKey(timestamp));
  }

  getLatestAllowedEndDate() {
    const allowedEndDates = this.calculateStartDates(true);
    const latestAllowedDate = allowedEndDates[allowedEndDates.length - 1];

    if (!latestAllowedDate) {
      return null;
    }

    const [yearString, monthString, dayString] = latestAllowedDate.split("-");
    const year = Number(yearString);
    const month = Number(monthString);
    const day = Number(dayString);

    if (
      Number.isNaN(year) ||
      Number.isNaN(month) ||
      Number.isNaN(day)
    ) {
      return null;
    }

    return firestore.Timestamp.fromDate(new Date(year, month - 1, day));
  }

  // Device assignment is only permitted if the device is currently assigned to the client in question.
  calculateStartDates(isForEndDate: boolean) {
    const dates: string[] = [];
    const datesToBeSkipped: string[] = [];
    const countingCoverage = this.countedViaExternalDevice
      ? this.countingCoverageForCurrentSelection
      : null;

    const countingAssignmentStartDateString = (() => {
      if (!countingCoverage) {
        return null;
      }

      const countingStartDate = new Date(
        toStartOfDay(countingCoverage.assignmentStartDate).toDate()
      );
      // Keep same normalization as currentDate/dateToBeAdded to avoid timezone drift.
      countingStartDate.setDate(countingStartDate.getDate() + 1);
      return countingStartDate.toISOString().split("T")[0];
    })();

    const countingAssignmentEndDateString = (() => {
      if (!countingCoverage?.assignmentEndDate) {
        return null;
      }

      const countingEndDate = new Date(
        toStartOfDay(countingCoverage.assignmentEndDate).toDate()
      );
      // Keep same normalization as currentDate/dateToBeAdded to avoid timezone drift.
      countingEndDate.setDate(countingEndDate.getDate() + 1);
      return countingEndDate.toISOString().split("T")[0];
    })();

    // For counting devices: the end date must be >= the latest dependent assignment end date.
    const minEndDateForCountingDevice = (() => {
      if (!isForEndDate) return null;

      const latestEnd = this.latestDependentAssignmentEndDate;
      if (!latestEnd) return null;

      const latestEndDate = new Date(toStartOfDay(latestEnd).toDate());
      latestEndDate.setDate(latestEndDate.getDate() + 1);
      return latestEndDate.toISOString().split("T")[0];
    })();

    const knownSince = this.deviceDetails?.knownSince ?? firestore.Timestamp.now();

    if (knownSince) {
      const assignmentStartDate = new Date(knownSince.toDate());
      const minDate = this.minDate?.toDate();
      
      // Use the later start date between the project and the assignment
      let currentDate = minDate && minDate > assignmentStartDate ? minDate : assignmentStartDate;
      const endDate: Date = this.maxEndDate.toDate();

      // Adjust the dates for comparison
      currentDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);

      /*
      * Adjust the timezone difference
      * Current date: GMT+0100 Central European Standard Time (CET)
      * Current date (ISO 8601): GMT+0000 Universal Time (UTC)
      */
      currentDate.setDate(currentDate.getDate() + 1);
      
      // Include end date in allowed dates
      endDate.setDate(endDate.getDate() + 1);
      
      while (currentDate <= endDate) {
        // Format as 'YYYY-MM-DD'
        const dateToBeAdded = currentDate.toISOString().split('T')[0];
        const timestampToBeChecked = firestore.Timestamp.fromDate(currentDate);
        const isBeforeCountingAssignmentStartDate =
          !!countingAssignmentStartDateString &&
          dateToBeAdded < countingAssignmentStartDateString;
        const isAfterCountingAssignmentEndDate =
          !!countingAssignmentEndDateString &&
          dateToBeAdded > countingAssignmentEndDateString;
        const isBeforeMinEndDateForCountingDevice =
          !!minEndDateForCountingDevice &&
          dateToBeAdded < minEndDateForCountingDevice;
        if (
          (!datesToBeSkipped.includes(dateToBeAdded) || isForEndDate) &&
          !isBeforeCountingAssignmentStartDate &&
          !isAfterCountingAssignmentEndDate &&
          !isBeforeMinEndDateForCountingDevice
        ) {
          dates.push(dateToBeAdded);
        }

        /*
        * Adjust the timezone difference
        * Current date: GMT+0100 Central European Standard Time (CET)
        * Current date (ISO 8601): GMT+0000 Universal Time (UTC)
        */
        currentDate = new Date(currentDate.setDate(currentDate.getDate() + 1));

        this.existingAssignments.forEach((existingAssignment) => {
          if (
            isDateIncludedInOtherAssignment(
              timestampToBeChecked,
              existingAssignment
            )
          ) {
            // Avoid overlapping device assignments to the project
            const dateToBeSkipped = currentDate.toISOString().split('T')[0];
            datesToBeSkipped.push(dateToBeSkipped);
          }
        });
      }
    }

    return dates;
  }

  doGenericAssignmentsCollide(
    leftStartDate: firestore.Timestamp,
    leftEndDate: firestore.Timestamp | null,
    right: GenericDeviceProjectAssignment
  ) {
    const leftStartDay = this.getNormalizedDayKey(leftStartDate);
    const leftEndDay = leftEndDate ? this.getNormalizedDayKey(leftEndDate) : null;
    const rightStartDay = this.getNormalizedDayKey(right.assignmentStartDate);
    const rightEndDay = right.assignmentEndDate
      ? this.getNormalizedDayKey(right.assignmentEndDate)
      : null;

    // Day-based boundary rule:
    // previous.end <= current.start and current.end <= next.start are both valid.
    if (rightEndDay !== null && rightEndDay <= leftStartDay) {
      return false;
    }

    if (leftEndDay !== null && leftEndDay <= rightStartDay) {
      return false;
    }

    return true;
  }

  getNormalizedDayKey(timestamp: firestore.Timestamp) {
    const date = toStartOfDay(timestamp).toDate();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  async validateAssignmentData(
    date: firestore.Timestamp,
    validateStartDate: boolean,
  ) {
    if (validateStartDate) {
      this.didValidateStartDate = true;
    } else {
      this.didValidateEndDate = true;
    }

    let validationResult = AssignmentValidationResult.SaveDisabled;

    if (validateStartDate) {
      validationResult = await this.validateStartDate(date);
    } else if (this.endDate) {
      validationResult = await this.validateEndDate(date);
    }

    if (validationResult !== AssignmentValidationResult.SaveDisabled) {
      const totalPowerConsumption = this.totalPowerConsumption;
      if (this.showEndMeterReading && totalPowerConsumption !== null && totalPowerConsumption < 0) {
        validationResult = AssignmentValidationResult.SaveDisabled;
      }
    }

    this.assignmentValidationResult = validationResult;
  }

  get maxAssignmentStartDate() {
    return this.endDate ?? this.maxEndDate;
  }

  get meterReadingStartInfo() {
    if (this.meterReadingStartHintValue !== null && this.meterReadingStartInput === "") {
      const formatted = formatFloat(this.meterReadingStartHintValue, 2);
      const suffix = this.meterReadingSuffix;
      return `(${formatted} ${suffix}?)`;
    }
    return null;
  }

  get meterReadingEndInfo() {
    return null;
  }

  get meterSectionTitle() {
    return this.isReleaseMode
      ? this.isOperatingHoursMode
        ? "Bitte geben Sie den Stand des Betriebsstunden am Ende der Zuweisung an."
        : "Bitte geben Sie den Stromzählerstand am Ende der Zuweisung an."
      : this.isCorrectionMode
        ? this.$t("assignDevice.meterReadingsForPowerConsumption").toString()
        : this.$t("assignDevice.powerConsumption").toString();
  }

  get assignmentHoursSectionTitle() {
    return this.$t("assignDevice.assignmentHoursPrompt").toString();
  }

  get assignmentOperatingHoursHint() {
    if (!this.startDate || !this.endDate) {
      return "";
    }

    const startDate = toStartOfDay(this.startDate).toDate();
    const endDate = toStartOfDay(this.endDate).toDate();
    const endPlusOneDate = new Date(endDate);
    endPlusOneDate.setDate(endPlusOneDate.getDate() + 1);

    const hours = Math.max(
      0,
      Math.round((endPlusOneDate.getTime() - startDate.getTime()) / (1000 * 60 * 60))
    );

    return this.$t("assignDevice.operationTimeHint", [
      hours,
      formatDateShort(this.startDate),
      formatDateShort(firestore.Timestamp.fromDate(endPlusOneDate)),
    ]).toString();
  }

  get calculatedConsumptionLabel() {
    return this.isOperatingHoursMode
      ? this.$t("assignDevice.powerConsumption").toString()
      : this.$t("assignDevice.formatCalculatedPowerConsumption").toString();
  }

  get totalPowerConsumption() {
    if (!this.showEndMeterReading) {
      return null;
    }

    const start = this.meterReadingStartInputInKwh;
    const end = this.meterReadingEndInputInKwh;

    if (isNaN(end) || isNaN(start)) {
      return null;
    }

    const delta = end - start;
    if (this.isOperatingHoursMode) {
      const powerConsumptionPerHour = this.powerConsumptionPerHour ?? 0;
      return (delta * powerConsumptionPerHour) / 1000;
    }

    return delta;
  }

  get totalPowerConsumptionString() {
    const totalPowerConsumption = this.totalPowerConsumption;

    if (totalPowerConsumption == null) {
      return null;
    }

    return formatFloat(totalPowerConsumption, 2);
  }

  async showNoUnassignedProgramChainFoundDialog() {
    return this.confirmationDialog.show({
      title: this.$t("assignDevice.errorStartDateTitle").toString(),
      message: this.$t(
        "assignDevice.noUnassignedProgramChainFoundMessage"
      ).toString(),
      acceptMessage: this.$t("assignIresDevice.assignAnyway").toString(),
      rejectMessage: this.$t("common.abort").toString(),
    });
  }

  getDynamicAttributeLabel(attributeType: DeviceAttributeType) {
    switch (attributeType) {
      case DeviceAttributeType.OPERATING_HOURS:
        return this.$t("allDevices.operatingHours").toString();
      case DeviceAttributeType.OPERATING_HOURS_FROM_ASSIGNMENT:
        return this.$t("allDevices.operatingHoursFromAssignment").toString();
      case DeviceAttributeType.COMMENT:
        return this.$t("allDevices.note").toString();
      default:
        return attributeType.toString();
    }
  }

  parseInputValueByType(attributeType: DeviceAttributeType) {
    const value = this.assignment?.input?.[attributeType] ?? "";

    if (!value) {
      return "";
    }

    try {
      const parsed = JSON.parse(value) as { input?: string | number | null };
      const input = parsed?.input;
      return input === undefined || input === null ? "" : input.toString();
    } catch (e) {
      return value;
    }
  }

  getAssignmentStartMeterReading(assignment: GenericDeviceProjectAssignment) {
    const startFromMeterInfo = assignment.meterReadingInfo?.meterReadingStartKWh;
    if (typeof startFromMeterInfo === "number" && !isNaN(startFromMeterInfo)) {
      return startFromMeterInfo;
    }

    const powerInput = extractPowerConsumptionInput(assignment.input ?? {});
    const startFromInput = powerInput?.startValue;
    if (typeof startFromInput === "number" && !isNaN(startFromInput)) {
      return startFromInput;
    }

    return null;
  }

  getAssignmentEndMeterReading(assignment: GenericDeviceProjectAssignment) {
    const endFromMeterInfo = assignment.meterReadingInfo?.meterReadingEndKWh;
    if (typeof endFromMeterInfo === "number" && !isNaN(endFromMeterInfo)) {
      return endFromMeterInfo;
    }

    const powerInput = extractPowerConsumptionInput(assignment.input ?? {});
    const endFromInput = powerInput?.endValue;
    if (typeof endFromInput === "number" && !isNaN(endFromInput)) {
      return endFromInput;
    }

    return null;
  }

  getPreviousAssignmentForStartDate(startDate: firestore.Timestamp) {
    const startDay = this.getNormalizedDayKey(startDate);

    return this.existingAssignments
      .filter((assignment) => !!assignment.assignmentEndDate)
      .filter(
        (assignment) =>
          assignment.assignmentEndDate !== null &&
          this.getNormalizedDayKey(assignment.assignmentEndDate) <= startDay
      )
      .sort((left, right) => {
        const leftEnd = left.assignmentEndDate?.toMillis() ?? 0;
        const rightEnd = right.assignmentEndDate?.toMillis() ?? 0;
        return rightEnd - leftEnd;
      })[0];
  }

  getProposedReleaseMeterReadingEnd() {
    return this.meterReadingStart.meterReadingInKWh ?? 0;
  }

  getAssignmentHoursFromInput() {
    const assignmentInput = this.assignment?.input?.[DeviceAttributeType.OPERATING_HOURS_FROM_ASSIGNMENT];
    if (!assignmentInput) {
      return null;
    }

    try {
      const parsed = JSON.parse(assignmentInput) as DeviceAssignmentPowerInput;
      return typeof parsed?.operatingHours === "number" ? parsed.operatingHours : null;
    } catch (e) {
      return null;
    }
  }

  resetDynamicAttributeInputs() {
    this.assignmentAttributeInputs = {};
    this.dynamicAssignmentFields.forEach((field) => {
      this.assignmentAttributeInputs[field.type] = this.parseInputValueByType(field.type);
    });
  }

  formatAssignmentRange(
    startDate: firestore.Timestamp,
    endDate: firestore.Timestamp | null
  ) {
    if (!endDate) {
      return this.$t("common.startingAt", [formatDateShort(startDate)]).toString();
    }

    if (areOnSameDay(startDate, endDate)) {
      return formatDateShort(startDate);
    }

    return this.$t("common.sinceUntil", [formatDateShort(startDate), formatDateShort(endDate)]).toString();
  }

  async validateStartDate(
    newStartDate: firestore.Timestamp
  ): Promise<AssignmentValidationResult> {
    const newStartDay = this.getNormalizedDayKey(newStartDate);
    const assignmentsToValidate = this.isCreateMode
      ? this.existingAssignments.filter(
          (assignment) =>
            this.getNormalizedDayKey(assignment.assignmentStartDate) <= newStartDay
        )
      : this.existingAssignments;

    const collidingAssignment = assignmentsToValidate.find((assignment) =>
      this.doGenericAssignmentsCollide(newStartDate, this.endDate, assignment)
    );

    if (collidingAssignment) {
      await this.showCollidingAssignmentInfo(newStartDate, collidingAssignment);
      return AssignmentValidationResult.SaveDisabled;
    }

    return AssignmentValidationResult.SaveData;
  }

  async validateEndDate(
    newEndDate: firestore.Timestamp
  ): Promise<AssignmentValidationResult> {
    const collidingAssignment = this.existingAssignments.find((assignment) =>
      this.doGenericAssignmentsCollide(this.startDate, toEndOfDay(newEndDate), assignment)
    );

    if (collidingAssignment) {
      await this.confirmationDialog.show({
        title: this.$t("assignDevice.errorEndDateTitle").toString(),
        message: this.$t("assignDevice.collidingAssignment", [
          formatDateShort(newEndDate),
          formatDateShort(collidingAssignment.assignmentStartDate),
        ]).toString(),
        acceptMessage: null,
        rejectMessage: this.$t("common.abort").toString(),
      });

      return AssignmentValidationResult.SaveDisabled;
    }

    return AssignmentValidationResult.SaveData;
  }

  @Watch("meterReadingStart")
  onMeterReadingStartChanged(meterReadingStart: MeterReadingInfo) {
    this.meterReadingStartInput = formatFloat(
      meterReadingStart.meterReadingInKWh,
      2
    );
  }

  @Watch("meterReadingEnd")
  onMeterReadingEndChanged(meterReadingEnd: MeterReadingInfo) {
    if (!this.showEndMeterReading) {
      this.meterReadingEndInput = "";
      return;
    }

    if (
      meterReadingEnd.meterReadingInKWh !== undefined &&
      meterReadingEnd.meterReadingInKWh !== null
    ) {
      this.meterReadingEndInput = formatFloat(
        meterReadingEnd.meterReadingInKWh,
        2
      );
    }
  }

  @Watch("startDate")
  onStartDatePicked() {
    if (!this.startedForAssignmentCreation) {
      this.updateMaxEndDate();
    }
  }

  async onStartDateChanged(newStartDate: firestore.Timestamp) {
    if (!newStartDate) {
      return;
    }

    this.meterReadingEndError = [];
    this.countingDeviceErrorMessages = [];

    if (!this.startedForAssignmentCreation) {
      this.updateMaxEndDate();
    }

    if (this.startedForAssignmentCreation) {
      const previousAssignment = this.getPreviousAssignmentForStartDate(newStartDate);
      const previousEndMeterReading = previousAssignment
        ? this.getAssignmentEndMeterReading(previousAssignment)
        : null;

      // Determine the proposed start value
      let proposedValue: number;
      if (typeof previousEndMeterReading === "number" && !isNaN(previousEndMeterReading)) {
        proposedValue = previousEndMeterReading;
      } else if (this.deviceDetails?.lastMeterReading !== undefined && this.deviceDetails.lastMeterReading !== null) {
        proposedValue = this.deviceDetails.lastMeterReading;
      } else {
        proposedValue = 0;
      }

      // Check if the previous assignment's end meter reading was explicitly entered
      const hasExplicitPreviousEndReading = previousAssignment
        ? (typeof previousAssignment.meterReadingInfo?.meterReadingEndKWh === "number"
            && !isNaN(previousAssignment.meterReadingInfo.meterReadingEndKWh))
        : true;

      if (previousAssignment && !hasExplicitPreviousEndReading) {
        // Previous assignment exists but end reading not explicitly entered.
        // Leave field empty and show proposed value as hint.
        this.meterReadingStartHintValue = proposedValue;
        this.meterReadingStart = { meterReadingInKWh: proposedValue };
        this.$nextTick(() => { this.meterReadingStartInput = ""; });
      } else {
        this.meterReadingStartHintValue = null;
        this.meterReadingStart = { meterReadingInKWh: proposedValue };
      }
    } else if (
      areOnSameDay(toStartOfDay(newStartDate), this.assignment.assignmentStartDate) &&
      this.assignment.meterReadingInfo?.meterReadingStartKWh !== undefined &&
      this.assignment.meterReadingInfo?.meterReadingStartKWh !== null
    ) {
      this.meterReadingStart = {
        meterReadingInKWh: this.assignment.meterReadingInfo.meterReadingStartKWh,
      };
    } else if (this.deviceDetails?.lastMeterReading !== undefined && this.deviceDetails.lastMeterReading !== null) {
      this.meterReadingStart = {
        meterReadingInKWh: this.deviceDetails.lastMeterReading,
      };
    }

    this.proposedMeterReadingStart = this.meterReadingStart;

    if (this.endDate) {
      await this.onEndDateChanged(this.endDate, true);
    }

    await this.validateAssignmentData(newStartDate, true);
  }

  async onEndDateChanged(date: firestore.Timestamp, ignoreEndDateProposal?: boolean) {
    if (!date) {
      return;
    }

    this.meterReadingEndError = [];
    this.countingDeviceErrorMessages = [];

    if (!ignoreEndDateProposal) {
      if (this.isReleaseMode) {
        this.meterReadingEnd = {
          meterReadingInKWh: this.getProposedReleaseMeterReadingEnd(),
          ignoreCorrectedBy: true,
        };
      } else {
        this.meterReadingEnd = this.meterReadingStart;
      }
    }

    this.proposedMeterReadingEnd = this.meterReadingEnd;
    this.validateMeterReadingEnd();
    await this.validateAssignmentData(date, false);
  }

  async deleteThisAssignment() {
    this.showProgressBar = true;

    try {
      await deleteGenericDeviceAssignments(this.targetProject, [this.assignment]);
      this.showSuccessSnackbar("assignDevice.assignmentDeletedSuccess");
    } catch (e) {
      this.showErrorSnackbar("assignDevice.assignmentDeletedError");
    } finally {
      this.showProgressBar = false;
    }

    this.onCancel();
  }

  calculateBaseDialogTitle() {
    const isStartedForAssignmentCreation = this.startedForAssignmentCreation;
    const isStartedForAssignmentCrorrection = this.startedForAssignmentCorrection;

    return (this.$t(
      `assignDevice.format${
        isStartedForAssignmentCreation 
          ? 'Assign' 
          : isStartedForAssignmentCrorrection 
            ? 'Correction' 
            : 'SignOff'
      }GenericDevice`, [
        this.genericDeviceOverviewToAssign.inventoryNumber,
        this.currentTemplate?.deviceName ?? "-"
      ]).toString());
  }

  async show(
    genericDeviceOverviewToAssign: DeviceOverview,
    targetProject: ProjectDetails,
    contactPerson: ContactPersonInfo,
    nextAssignmentIndex: number,
    existingAssignment?: GenericDeviceProjectAssignment,
    hasDependantAssignments?: boolean,
    // Room of a new assignment under room-level device assignment; an edit keeps the stored one.
    roomId: string | null = null,
  ) {
    if (
      !existingAssignment &&
      genericDeviceOverviewToAssign.currentlyAssigned &&
      genericDeviceOverviewToAssign.projectId !== targetProject.id
    ) {
      await this.confirmationDialog.show({
        title: this.$t("assignDevice.genericDeviceAlreadyAssignedTitle").toString(),
        message: this.$t("assignDevice.genericDeviceAlreadyAssignedMessage", [
          genericDeviceOverviewToAssign.inventoryNumber,
          genericDeviceOverviewToAssign.projectName ?? "",
        ]).toString(),
        acceptMessage: null,
        rejectMessage: this.$t("common.abort").toString(),
      });
      return false;
    }

    this.inventoryNumber = genericDeviceOverviewToAssign.inventoryNumber;
    this.lastMeterReadingEndTargetDate = null;
    this.lastMeterReadingStartTargetDate = null;
    this.countingAssignments = [];
    this.countedDeviceAssignments = [];
    this.countedViaExternalDevice = false;
    this.selectedCountingAssignmentId = null;
    this.countingDeviceErrorMessages = [];
    this.assignmentAttributeInputs = {};

    this.genericDeviceOverviewToAssign = genericDeviceOverviewToAssign;
    this.targetProject = targetProject;
    this.contactPerson = contactPerson;
    this.didLoadDeviceInfo = false;
    this.assignmentValidationResult = AssignmentValidationResult.NotValidated;

    this.meterReadingEndError = [];
    this.assignmentOperatingHoursError = [];
    this.meterReadingEndInput = "";
    this.meterReadingStartInput = "";
    this.assignmentOperatingHoursInput = "";
    this.electricityMeterNumber = genericDeviceOverviewToAssign.electricityMeterNumber ?? null;

    this.meterReadingStart = this.createEmptyMeterReadingInput();
    this.meterReadingEnd = this.createEmptyMeterReadingInput();
    this.maxEndDate = firestore.Timestamp.fromDate(new Date());

    const deviceDetails = await getGenericDeviceDetails(this.genericDeviceOverviewToAssign.id);
    this.deviceDetails = deviceDetails;
    this.currentTemplate = this.genericDeviceOverviewToAssign?.templateId
      ? getTemplateById(this.deviceSettingsJson, this.genericDeviceOverviewToAssign.templateId)
      : null;
    const deviceTemplate = this.currentTemplate;

    this.assignment = existingAssignment ?? {
      assignedDeviceCategoryId: genericDeviceOverviewToAssign.categoryId,
      assignedDeviceElectricityMeterManufacturer: genericDeviceOverviewToAssign.electricityMeterManufacturer ?? null,
      assignedDeviceElectricityMeterNumber: genericDeviceOverviewToAssign.electricityMeterNumber ?? null,
      assignedDeviceId: genericDeviceOverviewToAssign.id,
      assignedDeviceInventoryNumber: genericDeviceOverviewToAssign.inventoryNumber,
      assignedDeviceName: calculateAssignedDeviceName(deviceTemplate, genericDeviceOverviewToAssign.inventoryNumber),
      assignedDeviceTemplateId: genericDeviceOverviewToAssign.templateId,
      assignedProjectName: targetProject.clientData.projectName ?? "",
      assignedProjectNumber: targetProject.clientData.projectNumber ?? "",
      assignedProjectId: targetProject.id,
      assignmentEndDate: null,
      assignmentIndex: nextAssignmentIndex,
      assignmentStartDate: firestore.Timestamp.now(),
      contactPersonId: contactPerson.id,
      roomId,
      createdBy: { 
        recordedAt: firestore.Timestamp.now(),
        recordedByUserId: getActiveUser()?.id ?? ""
      },
      deviceOverviewPageNumber: genericDeviceOverviewToAssign.pageNumber ?? 0,
      electricityMeterForOtherDevices: deviceTemplate
        ? canBeUsedAsElectricityMeterForOtherDevices(deviceTemplate)
        : false,
      externalElectricityMeterInfo: null,
      id: generateRandomUuid(),
      meterReadingInfo: null,
      note: null,
      projectPhase: ProjectPhase.DRYING,
      input: {}
    };

    this.note = this.assignment.note ?? null;
    this.countedViaExternalDevice = this.assignment.externalElectricityMeterInfo !== null;
    this.selectedCountingAssignmentId = this.assignment.externalElectricityMeterInfo?.assignmentId ?? null;
    this.useForElectricityBilling = extractPowerConsumptionInput(this.assignment.input)?.userForReport ?? true;
    const existingAssignmentHours = this.getAssignmentHoursFromInput();
    this.assignmentOperatingHoursInput = existingAssignmentHours !== null ? existingAssignmentHours.toString() : "";
    this.resetDynamicAttributeInputs();

    //Delay to fix lag when dialog gets opened
    await new Promise((resolve) => setTimeout(resolve, 300));

    this.startDate = this.assignment.assignmentStartDate;
    this.endDate = this.assignment.assignmentEndDate;

    this.startedForAssignmentCreation = !existingAssignment;
    this.startedForAssignmentCorrection = !!existingAssignment?.assignmentEndDate;

    if (existingAssignment) {
      this.wasActiveAssignment = existingAssignment.assignmentEndDate === null;
    }

    const projectStartDate = targetProject.clientData.projectStartDate;
    this.minDate = projectStartDate;

    this.existingAssignments = (await getAllGenericDeviceAssignmentsStartedOrEndedAfter(
      genericDeviceOverviewToAssign.id,
      projectStartDate
    )).filter((existingAssignment) => this.assignment.id !== existingAssignment.id);

    if (this.startedForAssignmentCorrection) {
      // If there is an open assignment, don't consider it.
      this.existingAssignments = this.existingAssignments.filter((existingAssignment) => existingAssignment.assignmentEndDate);
    }

    // Prevent backward assignments: the earliest allowed start date must be at or after
    // the latest existing assignment boundary (see computeMinDateForGenericAssignment).
    this.minDate = computeMinDateForGenericAssignment(
      projectStartDate,
      this.existingAssignments,
      this.deviceDetails?.knownSince,
    );

    // For release mode, propose today's date (day-based).
    if (!this.startedForAssignmentCreation && !this.startedForAssignmentCorrection) {
      const today = toStartOfDay(firestore.Timestamp.fromDate(new Date()));
      this.endDate = today.toMillis() < this.startDate.toMillis() ? this.startDate : today;
    }

    this.didLoadDeviceInfo = true;

    await this.loadCountingAssignments();

    // Counting devices cannot be released while dependent devices are still active.
    if (this.isReleaseMode && this.isCountingDevice && this.hasActiveDependentAssignments) {
      await this.confirmationDialog.show({
        title: this.$t("assignDevice.errorEndDateTitle").toString(),
        message: this.$t("assignDevice.countingDeviceHasActiveDependentsError").toString(),
        acceptMessage: null,
        rejectMessage: null,
      });
      return false;
    }

    if (!this.startedForAssignmentCreation) {
      const latestAllowedEndDate = this.getLatestAllowedEndDate();
      if (
        latestAllowedEndDate &&
        (!this.endDate || !this.isAllowedEndDate(this.endDate))
      ) {
        this.endDate = latestAllowedEndDate;
      }
    }

    this.showContent = true;
    this.baseDialogComponent.show({
      title: this.calculateBaseDialogTitle(),
      closeOnSave: false,
      maxWidth: 700,
      neutralButtonText: this.startedForAssignmentCreation || hasDependantAssignments
        ? undefined
        : this.$t("common.delete").toString(),
      persistent: false,
    });

    this.showProgressBar = true;

    if (this.startedForAssignmentCreation) {
      await this.onStartDateChanged(this.startDate);
    } else {
      const startMeterReading = this.getAssignmentStartMeterReading(this.assignment);
      const endMeterReading = this.getAssignmentEndMeterReading(this.assignment);

      if (typeof startMeterReading === "number" && !isNaN(startMeterReading)) {
        this.meterReadingStart = {
          meterReadingInKWh: startMeterReading,
          ignoreCorrectedBy: true,
        };
      }

      if (typeof endMeterReading === "number" && !isNaN(endMeterReading)) {
        this.meterReadingEnd = {
          meterReadingInKWh: endMeterReading,
          ignoreCorrectedBy: true,
        };
      }
      this.proposedMeterReadingStart = this.meterReadingStart;
      this.proposedMeterReadingEnd = this.meterReadingEnd;
    }

    if (!this.startedForAssignmentCreation && !this.endDate) {
      const newEndDate = firestore.Timestamp.fromDate(new Date());
      await this.onEndDateChanged(newEndDate);
      this.endDatePicker.setNewTimestamp(newEndDate);
    } else if (!this.startedForAssignmentCreation && this.endDate) {
      await this.onEndDateChanged(this.endDate, true);
    }

    this.showProgressBar = false;

    return new Promise<boolean>((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  updateMaxEndDate() {
    this.maxEndDate = firestore.Timestamp.fromDate(new Date());
    const selectedStartDay = this.getNormalizedDayKey(this.startDate);

    const nextAssignment = this.existingAssignments
      .filter(
        (assignment) =>
          this.getNormalizedDayKey(assignment.assignmentStartDate) > selectedStartDay
      )
      .sort(
        (left, right) =>
          left.assignmentStartDate.toMillis() - right.assignmentStartDate.toMillis()
      )[0];

    // If there exists an assignment after the selected start date, limit the selection of the end date to the start date of the next assignment.
    if (nextAssignment && nextAssignment.assignmentStartDate.seconds < this.maxEndDate.seconds) {
      this.maxEndDate = nextAssignment.assignmentStartDate;
    }
  }

  async loadCountingAssignments() {
    const [genericAssignments, panelAssignments] = await Promise.all([
      getGenericDeviceAssignmentsOfProject(this.targetProject.id),
      getClientPanelAssignmentsOfProject(this.targetProject.id),
    ]);

    const genericCandidates = genericAssignments
      .filter((assignment) => assignment.id !== this.assignment.id)
      .filter((assignment) => assignment.electricityMeterForOtherDevices)
      .filter((assignment) => assignment.externalElectricityMeterInfo === null)
      .map((assignment) => ({
        id: assignment.id,
        assignmentStartDate: assignment.assignmentStartDate,
        assignmentEndDate: assignment.assignmentEndDate,
        effectiveMaxEndDate: null,
        deviceName: assignment.assignedDeviceName,
        deviceId: assignment.assignedDeviceId,
        type: ExternalElectricityMeterType.OTHER,
      } as CountingAssignmentCandidate));

    const countedGenericAssignments = genericAssignments.filter(
      (assignment) => assignment.externalElectricityMeterInfo?.assignmentId === this.assignment.id
    );
    const countedPanelAssignments = panelAssignments.filter(
      (assignment) => assignment.externalElectricityMeterInfo?.assignmentId === this.assignment.id
    );
    this.countedDeviceAssignments = [
      ...countedGenericAssignments,
      ...countedPanelAssignments.map((assignment) => ({
        ...assignment,
        assignedDeviceName: getClientPanelDisplayNameFromAssignment(assignment),
        assignedDeviceId: assignment.serialNumber,
      } as unknown as GenericDeviceProjectAssignment)),
    ];

    const panelCandidates: CountingAssignmentCandidate[] = panelAssignments
      .filter((assignment) => assignment.electricityMeterForOtherDevices)
      .filter((assignment) => assignment.externalElectricityMeterInfo === null)
      .map((assignment) => ({
        id: assignment.id,
        assignmentStartDate: assignment.assignmentStartDate,
        assignmentEndDate: assignment.assignmentEndDate,
        effectiveMaxEndDate: null,
        deviceName: getClientPanelDisplayNameFromAssignment(assignment),
        deviceId: assignment.serialNumber,
        type: getIresDeviceCategoryFromSerialNumber(assignment.serialNumber) === IresDeviceCategory.COMBOX
          ? ExternalElectricityMeterType.COM_BOX
          : ExternalElectricityMeterType.OTHER,
      } as CountingAssignmentCandidate));

    // For open IRES assignments, compute the effective max end date from the
    // next assignment of the same serial number so counted devices are
    // constrained to valid dates.
    const openPanelCandidates = panelCandidates.filter((c) => c.assignmentEndDate === null);
    await Promise.all(
      openPanelCandidates.map(async (candidate) => {
        const nextAssignment = await getNextAssignmentStartedAfter(
          candidate.deviceId,
          candidate.assignmentStartDate
        );
        if (nextAssignment) {
          // Use the next assignment's start date directly (not minus one day)
          // because IRES assignments can end and start on the same day.
          candidate.effectiveMaxEndDate = toStartOfDay(nextAssignment.assignmentStartDate);
        }
      })
    );

    this.countingAssignments = [...panelCandidates, ...genericCandidates];
  }

  async onExternalCountingToggle(value: boolean) {
    this.countedViaExternalDevice = !!value;
    this.countingDeviceErrorMessages = [];

    if (!this.countedViaExternalDevice) {
      this.selectedCountingAssignmentId = null;
      this.showCountingDeviceDialog = false;
      return;
    }

    await this.openCountingDeviceSelectionDialog();
  }

  async openCountingDeviceSelectionDialog() {
    this.countingDeviceErrorMessages = [];

    if (this.countingDeviceOptions.length === 0) {
      await this.confirmationDialog.show({
        title: this.$t("assignDevice.selectCountingDeviceTitle").toString(),
        message: this.$t("allDevices.noMatchingDevicesFound").toString(),
        acceptMessage: this.$t("common.close").toString(),
        rejectMessage: null,
      });
      this.countedViaExternalDevice = false;
      this.selectedCountingAssignmentId = null;
      this.showCountingDeviceDialog = false;
      return;
    }

    this.showCountingDeviceDialog = true;
  }

  async onCountingDeviceOptionClicked(option: { value: string; text: string; disabled: boolean }) {
    if (option.disabled) {
      const assignment = this.selectableCountingAssignments.find((a) => a.id === option.value);
      const deviceName = assignment?.deviceName ?? "";
      await this.confirmationDialog.show({
        title: this.$t("assignDevice.errorEndDateTitle").toString(),
        message: this.$t("assignDevice.countingDeviceWindowBeforeMinDate", [deviceName]).toString(),
        acceptMessage: this.$t("common.ok").toString(),
        rejectMessage: null,
      });
      return;
    }

    await this.onSelectCountingDevice(option.value);
  }

  async onSelectCountingDevice(assignmentId: string) {
    this.selectedCountingAssignmentId = assignmentId;
    this.countingDeviceErrorMessages = [];
    let didAdjustDatesForCountingDevice = false;
    let selectedCountingDeviceNameForHint = "";

    const selectedCountingAssignment = this.selectedCountingAssignment;
    if (selectedCountingAssignment) {
      const countingAssignmentStartDate = toStartOfDay(
        selectedCountingAssignment.assignmentStartDate
      );
      const effectiveEndTimestamp = selectedCountingAssignment.assignmentEndDate
        ?? selectedCountingAssignment.effectiveMaxEndDate;
      const countingEndDate = effectiveEndTimestamp
        ? toStartOfDay(effectiveEndTimestamp)
        : null;
      selectedCountingDeviceNameForHint = selectedCountingAssignment.deviceName;

      // Adjust start date if it falls before the counting assignment start.
      if (this.startDate.toMillis() < countingAssignmentStartDate.toMillis()) {
        this.startDate = countingAssignmentStartDate;
        this.startDatePicker?.setNewTimestamp(countingAssignmentStartDate);
        await this.onStartDateChanged(countingAssignmentStartDate);
        didAdjustDatesForCountingDevice = true;
      }

      // Adjust end date if it exceeds the counting assignment's end date.
      if (countingEndDate && this.endDate) {
        if (this.endDate.toMillis() > countingEndDate.toMillis()) {
          this.endDate = countingEndDate;
          this.endDatePicker?.setNewTimestamp(countingEndDate);
          await this.onEndDateChanged(countingEndDate, true);
          didAdjustDatesForCountingDevice = true;
        }
      }

      // If start date now exceeds the end date, clamp start to counting start.
      if (countingEndDate && this.startDate.toMillis() > countingEndDate.toMillis()) {
        this.startDate = countingAssignmentStartDate;
        this.startDatePicker?.setNewTimestamp(countingAssignmentStartDate);
        await this.onStartDateChanged(countingAssignmentStartDate);
        didAdjustDatesForCountingDevice = true;
      }
    }

    this.showCountingDeviceDialog = false;

    if (didAdjustDatesForCountingDevice) {
      await this.confirmationDialog.show({
        title: this.$t("assignDevice.externalCountingStartDateAdjustedTitle").toString(),
        message: this.$t("assignDevice.externalCountingStartDateAdjustedMessage", [
          selectedCountingDeviceNameForHint,
        ]).toString(),
        acceptMessage: this.$t("common.ok").toString(),
        rejectMessage: null,
      });
    }
  }

  onClearCountingDeviceSelection() {
    this.selectedCountingAssignmentId = null;
    this.countedViaExternalDevice = false;
    this.countingDeviceErrorMessages = [];
    this.showCountingDeviceDialog = false;
  }

  closeCountingDeviceDialog() {
    if (!this.selectedCountingAssignmentId) {
      this.countedViaExternalDevice = false;
    }

    this.showCountingDeviceDialog = false;
  }

  onCountingDeviceDialogVisibilityChanged(isVisible: boolean) {
    this.showCountingDeviceDialog = isVisible;

    if (!isVisible && this.countedViaExternalDevice && !this.selectedCountingAssignmentId) {
      this.countedViaExternalDevice = false;
      this.countingDeviceErrorMessages = [];
    }
  }

  get meterReadingStartInputInKwh() {
    return parseLocalizedFloat(this.meterReadingStartInput);
  }

  get meterReadingEndInputInKwh() {
    return parseLocalizedFloat(this.meterReadingEndInput);
  }

  async collectAssignmentInfo() {
    const assignmentUpdate = clone(this.assignment);
    const now = new Date();

    if (!assignmentUpdate.electricityMeterNumber && this.electricityMeterNumber) {
      assignmentUpdate.electricityMeterNumber = this.electricityMeterNumber;
    }

    assignmentUpdate.assignmentStartDate = toStartOfDay(this.startDate);
    assignmentUpdate.assignmentEndDate = this.endDate
      ? areDatesOnSameDay(this.endDate.toDate(), now)
        ? firestore.Timestamp.fromDate(now)
        : toEndOfDay(this.endDate)
      : null;

    if (
      assignmentUpdate.assignmentEndDate &&
      assignmentUpdate.assignmentEndDate.toMillis() < assignmentUpdate.assignmentStartDate.toMillis()
    ) {
      await this.confirmationDialog.show({
        title: this.$t("assignDevice.errorEndDateTitle").toString(),
        message: this.$t("assignDevice.collidingAssignment", [
          formatDateShort(assignmentUpdate.assignmentEndDate),
          formatDateShort(assignmentUpdate.assignmentStartDate),
        ]).toString(),
        acceptMessage: null,
        rejectMessage: this.$t("common.abort").toString(),
      });
      return null;
    }

    // Validate counting device release constraints.
    if (this.isCountingDevice && assignmentUpdate.assignmentEndDate) {
      if (this.hasActiveDependentAssignments) {
        await this.confirmationDialog.show({
          title: this.$t("assignDevice.errorEndDateTitle").toString(),
          message: this.$t("assignDevice.countingDeviceHasActiveDependentsError").toString(),
          acceptMessage: null,
          rejectMessage: this.$t("common.abort").toString(),
        });
        return null;
      }

      const latestDependentEnd = this.latestDependentAssignmentEndDate;
      if (
        latestDependentEnd &&
        assignmentUpdate.assignmentEndDate.toMillis() < latestDependentEnd.toMillis()
      ) {
        await this.confirmationDialog.show({
          title: this.$t("assignDevice.errorEndDateTitle").toString(),
          message: this.$t("assignDevice.countingDeviceEndDateTooEarlyError", [
            formatDateShort(latestDependentEnd)
          ]).toString(),
          acceptMessage: null,
          rejectMessage: this.$t("common.abort").toString(),
        });
        return null;
      }
    }

    assignmentUpdate.meterReadingInfo = this.assignment.meterReadingInfo ?? {};
    assignmentUpdate.input = assignmentUpdate.input ?? {};
    assignmentUpdate.note = this.note?.trim() ? this.note.trim() : null;

    const selectedPowerMode = this.currentTemplate
      ? selectedPowerConsumptionMode(this.currentTemplate)
      : null;
    const requiresMeterValidation = selectedPowerMode !== null;

    const meterReadingStartKWh = this.meterReadingStartInputInKwh;
    const meterReadingEndKWh = this.meterReadingEndInputInKwh;
    if (
      requiresMeterValidation &&
      !this.shouldSkipMeterReadingEnforcement &&
      this.endDate &&
      (isNaN(meterReadingEndKWh) || meterReadingStartKWh > meterReadingEndKWh)
    ) {
      this.meterReadingEndError = [
        this.$t("assignDevice.errorMeterReadingStart").toString(),
      ];
      return null;
    }

    if (this.isStrictCounterCheckingEnabled && !this.shouldSkipMeterReadingEnforcement) {
      if (requiresMeterValidation && isNaN(meterReadingStartKWh)) {
        this.meterReadingEndError = [
          this.$t("assignDevice.errorMeterReadingStart").toString(),
        ];
        return null;
      }

      if (requiresMeterValidation && this.endDate && isNaN(meterReadingEndKWh)) {
        this.meterReadingEndError = [
          this.$t("assignDevice.errorMeterReadingEnd").toString(),
        ];
        return null;
      }
    }

    if (requiresMeterValidation && !isNaN(meterReadingStartKWh)) {
      assignmentUpdate.meterReadingInfo.meterReadingStartKWh = meterReadingStartKWh;
    }

    if (requiresMeterValidation && !isNaN(meterReadingEndKWh) && this.endDate) {
      assignmentUpdate.meterReadingInfo.meterReadingEndKWh = meterReadingEndKWh;
    }

    DEVICE_POWER_INPUT_ATTRIBUTE_TYPES.forEach((powerInputType) => {
      delete assignmentUpdate.input[powerInputType];
    });

    if (selectedPowerMode === DeviceAttributeType.OPERATING_HOURS_FROM_ASSIGNMENT) {
      const assignmentOperatingHours = parseLocalizedFloat(this.assignmentOperatingHoursInput);
      if (this.isEditMode && (isNaN(assignmentOperatingHours) || assignmentOperatingHours < 0)) {
        this.assignmentOperatingHoursError = [
          this.$t("assignDevice.errorMeterReadingStart").toString(),
        ];
        return null;
      }

      const assignmentPowerInput: DeviceAssignmentPowerInput = {
        operatingHours:
          !isNaN(assignmentOperatingHours) && assignmentOperatingHours >= 0
            ? Math.round(assignmentOperatingHours)
            : null,
        userForReport: this.useForElectricityBilling,
        wasConfirmed: false,
      };
      assignmentUpdate.input[DeviceAttributeType.OPERATING_HOURS_FROM_ASSIGNMENT] =
        JSON.stringify(assignmentPowerInput);
    } else if (selectedPowerMode) {
      const powerConsumptionInput: DevicePowerConsumptionInput = {
        startValue: !isNaN(meterReadingStartKWh) ? meterReadingStartKWh : null,
        endValue: this.endDate && !isNaN(meterReadingEndKWh) ? meterReadingEndKWh : null,
        userForReport: this.useForElectricityBilling,
      };
      assignmentUpdate.input[selectedPowerMode] = JSON.stringify(powerConsumptionInput);
    }

    this.dynamicAssignmentFields.forEach((field) => {
      const value = this.assignmentAttributeInputs[field.type];
      const normalizedValue = value?.toString().trim() ?? "";

      if (normalizedValue === "") {
        delete assignmentUpdate.input[field.type];
      } else {
        assignmentUpdate.input[field.type] = JSON.stringify({ input: normalizedValue });
      }
    });

    const didSetExternalMeterInfo = this.trySetExternalMeterInfo(assignmentUpdate);
    if (!didSetExternalMeterInfo) {
      return null;
    }

    return assignmentUpdate;
  }

  trySetExternalMeterInfo(assignmentUpdate: GenericDeviceProjectAssignment) {
    if (!this.countedViaExternalDevice) {
      assignmentUpdate.externalElectricityMeterInfo = null;
      return true;
    }

    if (!this.selectedCountingAssignmentId) {
      this.countingDeviceErrorMessages = [
        this.$t("common.select").toString(),
      ];
      return false;
    }

    const countingAssignment = this.countingAssignments.find(
      (assignment) => assignment.id === this.selectedCountingAssignmentId
    );

    if (!countingAssignment) {
      this.countingDeviceErrorMessages = [
        this.$t("assignDevice.noMatchingDeviceFound").toString(),
      ];
      return false;
    }

    if (this.isCreateMode && countingAssignment.assignmentEndDate) {
      this.countingDeviceErrorMessages = [
        this.$t("assignDevice.externalCountingOpenAssignmentError", [
          formatDateShort(countingAssignment.assignmentEndDate),
        ]).toString(),
      ];
      return false;
    }

    const startDate = assignmentUpdate.assignmentStartDate;
    const endDate = assignmentUpdate.assignmentEndDate;

    // Save validation uses the counting assignment's actual dates.
    // When the counting device is released, the Cloud Function
    // batch-updates all dependent assignments' externalElectricityMeterInfo dates.
    const isStartInRange = startDate.toMillis() >= countingAssignment.assignmentStartDate.toMillis();
    const isEndInRange = !endDate
      ? countingAssignment.assignmentEndDate === null
      : countingAssignment.assignmentEndDate === null || endDate.toMillis() <= countingAssignment.assignmentEndDate.toMillis();

    if (!isStartInRange || !isEndInRange) {
      if (!isStartInRange) {
        this.countingDeviceErrorMessages = [
          this.$t("assignDevice.externalCountingStartDateError", [
            formatDateShort(countingAssignment.assignmentStartDate),
          ]).toString(),
        ];
        return false;
      }

      if (!endDate && countingAssignment.assignmentEndDate) {
        this.countingDeviceErrorMessages = [
          this.$t("assignDevice.externalCountingOpenAssignmentError", [
            formatDateShort(countingAssignment.assignmentEndDate),
          ]).toString(),
        ];
        return false;
      }

      if (
        endDate &&
        countingAssignment.assignmentEndDate &&
        endDate.toMillis() > countingAssignment.assignmentEndDate.toMillis()
      ) {
        this.countingDeviceErrorMessages = [
          this.$t("assignDevice.externalCountingEndDateError", [
            formatDateShort(countingAssignment.assignmentEndDate),
          ]).toString(),
        ];
        return false;
      }
    }

    // Persist the counting assignment's actual dates in externalElectricityMeterInfo.
    assignmentUpdate.externalElectricityMeterInfo = {
      assignmentEndDate: countingAssignment.assignmentEndDate,
      assignmentId: countingAssignment.id,
      assignmentStartDate: countingAssignment.assignmentStartDate,
      deviceId: countingAssignment.deviceId,
      deviceName: countingAssignment.deviceName,
      type: countingAssignment.type,
    };
    this.countingDeviceErrorMessages = [];

    return true;
  }

  async showCollidingAssignmentInfo(
    date: firestore.Timestamp,
    collidingAssignment: DeviceProjectAssignment
  ) {
    const selectedStartDate = toStartOfDay(this.startDate ?? date);

    await this.confirmationDialog.show({
      title: this.$t("assignDevice.errorStartDateTitle").toString(),
      message: this.$t("assignDevice.collidingAssignment", [
        formatDateShort(selectedStartDate),
        formatDateShort(collidingAssignment.assignmentStartDate),
      ]).toString(),
      acceptMessage: null,
      rejectMessage: this.$t("common.abort").toString(),
    });
  }

  /**
   * Type guard for finite numeric values used in meter reading conversions.
   */
  isFiniteNumber(value: unknown): value is number {
    return typeof value === "number" && !isNaN(value);
  }

  /**
   * Computes the value persisted as `meterReadingBeforeLastAssignment`.
   * Returns null when no valid proposed start reading exists.
   */
  getMeterReadingBeforeLastAssignment() {
    const proposedStartReading = this.proposedMeterReadingStart?.meterReadingInKWh ?? null;
    return this.isFiniteNumber(proposedStartReading) ? proposedStartReading : null;
  }

  /**
   * Indicates whether assignments that reference this assignment as an external
   * electricity meter must be updated after saving.
   */
  shouldUpdateDependentExternalMeterDates() {
    return (
      !this.startedForAssignmentCreation &&
      this.assignment.electricityMeterForOtherDevices &&
      this.countedDeviceAssignments.length > 0
    );
  }

  /**
   * Returns the parsed release end reading or null if the current input is invalid.
   */
  getReleaseEndMeterReading() {
    return this.isFiniteNumber(this.meterReadingEndInputInKwh)
      ? this.meterReadingEndInputInKwh
      : null;
  }

  /**
   * Saves the generic assignment and applies all related side effects.
   * The write to the assigned device document is consolidated into the same
   * save operation via `deviceUpdatePatch` to avoid multiple writes to one doc.
   */
  async saveAssignment() {
    const assignmentUpdate = await this.collectAssignmentInfo();

    if (!assignmentUpdate) {
      return false;
    }

    if (this.startedForAssignmentCorrection) {
      await deleteGenericDeviceAssignments(this.targetProject, [this.assignment]);
      assignmentUpdate.id = generateRandomUuid();
    }

    const deviceUpdatePatch: Record<string, unknown> = {
      meterReadingBeforeLastAssignment: this.getMeterReadingBeforeLastAssignment(),
    };

    if (this.isReleaseMode) {
      const releaseEndReading = this.getReleaseEndMeterReading();

      if (releaseEndReading !== null) {
        deviceUpdatePatch.lastMeterReading = releaseEndReading;
      }
    }

    // Compute dependent assignment IDs upfront instead of calling updateExternalMeterDatesOfAssignedDevices separately
    const dependentAssignmentIds = this.shouldUpdateDependentExternalMeterDates()
      ? this.countedDeviceAssignments.map((a) => a.id)
      : [];

    const activeUser = getActiveUser();

    await saveGenericDeviceAssignment(
      assignmentUpdate,
      deviceUpdatePatch,
      dependentAssignmentIds,
      activeUser?.nickname,
      activeUser?.id,
      ProjectOperationSource.PORTAL
    );

    return true;
  }

  createEmptyMeterReadingInput() {
    return {
      canBeCorrected: true,
      meterReadingInKWh: 0,
    };
  }

  async onSave() {
    this.showProgressBar = true;

    const date = this.startedForAssignmentCreation
      ? this.startDate
      : this.endDate;

    if (!date) {
      this.showProgressBar = false;
      return;
    }

    let shouldValidateData = true;
    if (this.startedForAssignmentCreation) {
      shouldValidateData = !this.didValidateStartDate;
    } else {
      shouldValidateData = !this.didValidateEndDate;
    }

    if (shouldValidateData) {
      await this.validateAssignmentData(date, this.startedForAssignmentCreation);
    }

    if (
      this.assignmentValidationResult ===
      AssignmentValidationResult.SaveDisabled
    ) {
      this.showProgressBar = false;
      return;
    }

    let wasSaved = false;

    try {
      wasSaved = await this.saveAssignment();

      if (wasSaved) {
        if (this.isReleaseMode) {
          this.showSuccessSnackbar("assignDevice.assignmentReleasedSuccess");
        } else if (this.isCorrectionMode) {
          this.showSuccessSnackbar("assignDevice.assignmentCorrectedSuccess");
        } else {
          this.showSuccessSnackbar("assignDevice.assignmentSavedSuccess");
        }
      }
    } catch (e) {
      if (this.isReleaseMode) {
        this.showErrorSnackbar("assignDevice.assignmentReleasedError");
      } else if (this.isCorrectionMode) {
        this.showErrorSnackbar("assignDevice.assignmentCorrectedError");
      } else {
        this.showErrorSnackbar("assignDevice.assignmentSavedError");
      }
    } finally {
      this.showProgressBar = false;
    }

    if (wasSaved) {
      this.resetDialog();
      this.resolve && this.resolve(true);
    }
  }

  resetDialog() {
    this.baseDialogComponent.isShowing = false;
    this.showContent = false;

    this.existingAssignments = [];

    this.didLoadDeviceInfo = false;
    this.minDate = null;

    this.startDate = firestore.Timestamp.fromDate(new Date());
    this.endDate = null;

    this.maxEndDate = firestore.Timestamp.fromDate(new Date());
    this.countingAssignments = [];
    this.countedDeviceAssignments = [];
    this.showCountingDeviceDialog = false;
    this.selectedCountingAssignmentId = null;
    this.countedViaExternalDevice = false;
    this.countingDeviceErrorMessages = [];
    this.assignmentAttributeInputs = {};
    this.useForElectricityBilling = true;
    this.note = null;
    this.meterReadingStartHintValue = null;
    this.assignmentOperatingHoursInput = "";
    this.assignmentOperatingHoursError = [];
  }

  onCancel() {
    this.resetDialog();
    this.resolve && this.resolve(false);
  }

  onError(data: string) {
    this.showErrorSnackbar(data);
  }

  onSuccess(data: string) {
    this.showSuccessSnackbar(data);
  }

  showErrorSnackbar(message: string) {
    this.errorSnackbar = true;
    this.errorSnackbarText = message;
  }

  showSuccessSnackbar(message: string) {
    this.successSnackbar = true;
    this.successSnackbarText = message;
  }

  onMeterReadingStartManuallyChanged() {
    if (this.meterReadingStartInput !== "") {
      this.meterReadingStartHintValue = null;
    }
    this.clearMeterReadingErrorIfResolved();
  }

  async validateMeterReadingStart() {
    if (this.meterReadingStartInput === "" && this.meterReadingStartHintValue === null) {
      await this.onStartDateChanged(this.startDate);
      this.meterReadingStart = this.proposedMeterReadingStart;
    }
  }

  validateMeterReadingEnd() {
    if (this.meterReadingEndInput === "") {
      this.meterReadingEnd = this.proposedMeterReadingEnd;
    }
  }

  onMeterReadingEndManuallyChanged() {
    this.clearMeterReadingErrorIfResolved();
  }

  clearMeterReadingErrorIfResolved() {
    const startValue = this.meterReadingStartInputInKwh;
    const endValue = this.meterReadingEndInputInKwh;

    const hasStartValue = !isNaN(startValue);
    const hasEndValue = !isNaN(endValue);

    if (hasStartValue && startValue < 0) {
      return;
    }

    if (this.isStrictCounterCheckingEnabled && !this.shouldSkipMeterReadingEnforcement) {
      if (!hasStartValue) {
        return;
      }

      if (this.endDate && !hasEndValue) {
        return;
      }
    }

    if (this.endDate && hasStartValue && hasEndValue && endValue < startValue) {
      return;
    }

    this.meterReadingEndError = [];
  }

  async onDelete() {
    if (this.isCountingDevice && this.countedDeviceAssignments.length > 0) {
      await this.confirmationDialog.show({
        title: this.$t("assignDevice.deleteAssignmentTitle").toString(),
        message: this.$t("assignDevice.deviceAlreadyAssignedMessage", [
          formatDateShort(this.assignment.assignmentStartDate),
          this.assignment.assignmentEndDate
            ? formatDateShort(this.assignment.assignmentEndDate)
            : "-",
          this.assignment.assignedProjectName,
        ]).toString(),
        acceptMessage: null,
        rejectMessage: this.$t("common.abort").toString(),
      });
      return;
    }

    const didConfirmDeletion = await this.confirmationDialog.show({
      title: this.$t("assignDevice.deleteAssignmentTitle").toString(),
      message: this.$t("assignDevice.deleteAssignmentMessage").toString(),
    });

    if (didConfirmDeletion) {
      await this.deleteThisAssignment();
    }
  }
}
